﻿import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  DELETE_USER_TRADES,
  FETCH_FOLLOW_ENTITIES,
  FETCH_RELATED_TRADES,
  FETCH_RELATED_TRADES_FOR_WEB,
  FETCH_TRADE_NAMES,
  FETCH_TRADE_NAMES_FOR_WEB,
  FETCH_TRADES,
  FETCH_USERS_TRADES,
  GET_TRADE_DETAILS_FOR_WEB,
  GET_TRADE_MEMBERS,
  GET_USER_TRADES_EXPERIENCES,
  SAVE_FOLLOW_ENTITIES,
  SAVE_TRADE_NAMES,
  SAVE_USER_TRADES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardMedia,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  useMediaQuery,
  useTheme
} from "@mui/material";
import PlaceholderImg from "../../assets/images/trade_placeholder.jpg";
import PictureViewer from "../common/PictureViewer";
import { BIRed } from "../../assets/helpers";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Loader from "../../common/Loader";
import { Getrequestcall } from "../../request/Getrequest";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DeleteConfirmation from "../common/DeleteConfirmation";
import CheckIcon from "@mui/icons-material/Check";
import AddAnotherNameModal from "../common/AddAnotherNameModal";
import TradeAboutSection from "./TradeAboutSection";
import TradeCompanySection from "./TradeCompanySection";
import TradeProductSection from "./TradeProductSection";
import TradeProjectSection from "./TradeProjectSection";
import TradePostsSection from "./TradePostsSection";
import SendInChatModal from "../common/SendInChatModal";
import NoSuchPage from "../common/NoSuchPage";
import { setCommunityPostIds, setShowalert, setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { SignInCard } from "../common/SignInCard";
import MemberList from "../common/MemberList";
import { English } from "../../constant/EnglishFallback";
import Pageheader from "../common/Pageheader";
import Pages from "../../constant/ReportModel";

const TradeProfile = () => {
  let scrollTargetId = "scrollablediv_prodcut";
  let { id } = useParams();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Trades || {};
  const ENGLISH = English.Trades || {};
  const {
    BUTTON_ADD_ANOTHER_TRADE_NAME = ENGLISH.BUTTON_ADD_ANOTHER_TRADE_NAME,
    BUTTON_SEND_IN_CHAT = ENGLISH.BUTTON_SEND_IN_CHAT,
    BUTTON_SHARE = ENGLISH.BUTTON_SHARE,
    BUTTON_REPORT = ENGLISH.BUTTON_REPORT,
    TEXT_ARE_YOU_SURE_TO_UNFOLLOW_TRADE_PAGE = ENGLISH.TEXT_ARE_YOU_SURE_TO_UNFOLLOW_TRADE_PAGE,
    TEXT_REMOVE_THIS_TRADE = ENGLISH.TEXT_REMOVE_THIS_TRADE,
    BUTTON_YES = ENGLISH.BUTTON_YES,
    BUTTON_REMOVE = ENGLISH.BUTTON_REMOVE,
    BUTTON_ADD_TO_PROFILE = ENGLISH.BUTTON_ADD_TO_PROFILE,
    TEXT_ANOTHER_TRADE_NAME = ENGLISH.TEXT_ANOTHER_TRADE_NAME,
    TEXT_FOLLOWING = ENGLISH.TEXT_FOLLOWING,
    BUTTON_FOLLOW = ENGLISH.BUTTON_FOLLOW,
    TEXT_TRADE = ENGLISH.TEXT_TRADE,
    TEXT_THIS_TRADE_CANNOT_DELETED = ENGLISH.TEXT_THIS_TRADE_CANNOT_DELETED,
    TEXT_PRODUCTS = ENGLISH.TEXT_PRODUCTS,
    TEXT_COMPANIES = ENGLISH.TEXT_COMPANIES,
    TEXT_PROJECTS = ENGLISH.TEXT_PROJECTS,
    BUTTON_POSTS = ENGLISH.BUTTON_POSTS,
    TEXT_ADDED_ADMIN = ENGLISH.TEXT_ADDED_ADMIN
  } = LanguageData;

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIphone = /iPhone/i.test(navigator.userAgent);
  const isIpad = /iPad/i.test(navigator.userAgent);

  const [tradeData, setTradeData] = useState({
    tradeDetails: null,
    tradeList: [],
    pictureList: [],
    memberList: [],
    followDetails: null,
    tradeNames: [],
    relatedTradeNames: []
  });

  const [activeTab, setActiveTab] = useState("posts");
  const [showLoader, setShowLoader] = useState(true);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [isAddedToProfile, setIsAddedToProfile] = useState(false);
  const [isUserMainTrade, setIsUserMainTrade] = useState(false);
  const [showConformationModal, setShowConformationModal] = useState(null);
  const [showFollowLoader, setShowFollowLoader] = useState(false);
  const [showAddToProfileLoader, setShowAddToProfileLoader] = useState(false);
  const [showAddAnotherNameModal, setShowAddAnotherNameModal] = useState(false);
  const [anotherFormLoader, setAnotherFormLoader] = useState(false);
  const [isUserTradeListEmpty, setIsUserTradeListEmpty] = useState(false);
  const [showMemberList, setShowMemberList] = useState(false);
  const [showSendInChatModal, setShowSendInChatModal] = useState(false);
  const [noSuchData, setNoSuchData] = useState(false);
  const [showMemberBtnLoader, setShowMemberBtnLoader] = useState(false);
  const [userExpTradeIdArray, setUserExpTradeIdArray] = useState([]);
  const [currentTrade, setCurrentTrade] = useState([]);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [snackFlag, setSnackFlag] = useState(false);

  let menuOptions = [
    {
      name: "Add another Trade name",
      value: BUTTON_ADD_ANOTHER_TRADE_NAME
    },
    {
      name: "Send in Chat",
      value: BUTTON_SEND_IN_CHAT
    },
    {
      name: "Share",
      value: BUTTON_SHARE
    },
    {
      name: "Report",
      value: BUTTON_REPORT
    }
  ];

  let tabsOptions = [
    {
      name: "posts",
      value: BUTTON_POSTS
    },
    {
      name: "companies",
      value: TEXT_COMPANIES
    },
    {
      name: "products",
      value: TEXT_PRODUCTS
    },
    {
      name: "projects",
      value: TEXT_PROJECTS
    }
  ];

  useEffect(() => {
    if (pathname.includes("proxySite")) {
      getProxyPageData();
    } else if (id) {
      getData();
    }
  }, [id]);

  // Proxy sites start

  const getProxyPageData = async () => {
    setShowLoader(true);
    try {
      const [tradeDetails, tradeNames, relatedTradeNames] = await Promise.all([
        fetchTradeDetailsForWeb().catch((e) =>
          console.log("Error While Fetching Trade Details Data: ", e)
        ), // handle errors individually
        fetchTradeNamesForWeb().catch((e) =>
          console.log("Error While Fetching Trade Name Data: ", e)
        ),
        fetchRelatedTradesForWeb().catch((e) =>
          console.log("Error While Fetching Related Trade Data: ", e)
        )
      ]);

      setTradeData({
        tradeDetails,
        tradeNames,
        relatedTradeNames
      });
      openInPhone();
    } catch (error) {
      console.log("getProxyPageData-> Error When Fetching All Data Of Trade: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  function openInPhone() {
    if (isAndroid) {
      const androidUrl = `intent://?screenName=${"TradeDetail"}&id=${id}#Intent;scheme=mybuilderid;package=com.mybuilderid;end`;
      window.location.replace(androidUrl);
    } else if (isIphone || isIpad) {
      const iPhoneUrl = `mybuilderid://?screenName=${"TradeDetail"}&id=${id}`;
      window.location.replace(iPhoneUrl);
    }
  }

  const fetchTradeDetailsForWeb = async () => {
    try {
      const res = await Getrequestcall(`${GET_TRADE_DETAILS_FOR_WEB}/${id}`, undefined);
      let resData = res?.data?.data[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchTradeDetailsForWeb-> Error When Getting Trade Detail: ", error);
    }
  };

  const fetchTradeNamesForWeb = async () => {
    try {
      const obj = {
        SearchList: [{ TradeId: id }]
      };

      const res = await Postrequestcall(FETCH_TRADE_NAMES_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchTradeNamesForWeb-> Error When fetching Trade Name: ", error);
    }
  };

  const fetchRelatedTradesForWeb = async () => {
    try {
      const obj = {
        SearchList: [{ TradeId: id }]
      };

      const res = await Postrequestcall(FETCH_RELATED_TRADES_FOR_WEB, obj, undefined);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchRelatedTradesForWeb-> Error When Fetching Related Trade: ", error);
    }
  };

  // Proxy sites end
  const getData = async () => {
    setShowLoader(true);
    try {
      await fetchUserTrades();
      await getUserTradesExperiences();
      const [tradeDetails, memberList, followDetails, tradeNames, relatedTradeNames] =
        await Promise.all([
          fetchTradeDetails(), // handle errors individually
          fetchTradeMembers(),
          fetchFollowsEntity(),
          fetchTradeNames(),
          fetchRelatedTrades()
        ]);
      setTradeData({
        tradeDetails,
        memberList,
        followDetails,
        tradeNames,
        relatedTradeNames
      });
    } catch (error) {
      console.log("getData-> Error While fetching Trade All Data: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  const fetchTradeDetails = async () => {
    try {
      const obj = {
        SearchList: [{ id }]
      };
      const res = await Postrequestcall(FETCH_TRADES, obj, loginData?.accessToken);
      let resData = res?.data?.data[0] ?? null;
      setNoSuchData(resData ? false : true);
      return resData;
    } catch (error) {
      console.log("fetchTradeDetails-> Error While Fetching Trade Detail: ", error);
    }
  };

  const fetchTradeMembers = async () => {
    try {
      const res = await Getrequestcall(
        `${GET_TRADE_MEMBERS}/${currentUserId}/${id}`,
        loginData?.accessToken
      );
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchTradeMembers-> Error When Getting Trade Member List: ", error);
    }
  };

  const getUserTradesExperiences = async () => {
    try {
      const res = await Getrequestcall(
        `${GET_USER_TRADES_EXPERIENCES}/${currentUserId}`,
        loginData?.accessToken
      );
      let resData = res?.data?.data ?? [];
      const userTradeIdArray = resData.map((work) => work.tradeId);
      setUserExpTradeIdArray(userTradeIdArray);
    } catch (error) {
      console.log("getUserTradesExperiences-> Error When Getting User Trade Experience: ", error);
    }
  };

  const fetchFollowsEntity = async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        SearchList: [
          {
            EntityId: Number(id),
            userId: Number(currentUserId)
          }
        ]
      };

      const res = await Postrequestcall(FETCH_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      let resData = res?.data?.data?.[0] ?? null;
      return resData;
    } catch (error) {
      console.log("fetchFollowsEntity-> Error When Fetching Follow Entities: ", error);
    }
  };

  const fetchUserTrades = async () => {
    try {
      const obj = { SearchList: [{ UserId: currentUserId }] };
      const res = await Postrequestcall(FETCH_USERS_TRADES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      setIsUserTradeListEmpty(resData?.length === 0);
      const currentTrade = resData.filter((t) => Number(t.tradeId) == Number(id));
      const isTradeAddedToProfile = resData?.some((t) => t?.tradeId == id);
      const isUserAddedAsMainTrade = resData?.some(
        (t) => t?.tradeId === Number(id) && t.tradeType?.toLowerCase() === "main"
      );
      setIsAddedToProfile(isTradeAddedToProfile ?? false);
      setIsUserMainTrade(isUserAddedAsMainTrade ?? false);
      setCurrentTrade(currentTrade?.[0]?.tradeId);
    } catch (error) {
      console.log("fetchUserTrades-> Error When Fetching User Trade: ", error);
    }
  };

  const fetchTradeNames = async () => {
    try {
      const obj = {
        FetchAllowedRecordsOnly: true,
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        TypeOfObjectReturned: "",
        SearchList: [{ TradeId: id }]
      };

      const res = await Postrequestcall(FETCH_TRADE_NAMES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchTradeNames-> Error When Fetching Trade Name: ", error);
    }
  };

  const fetchRelatedTrades = async () => {
    try {
      const obj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        TypeOfObjectReturned: "",
        SearchList: [{ TradeId: id }]
      };

      const res = await Postrequestcall(FETCH_RELATED_TRADES, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      return resData;
    } catch (error) {
      console.log("fetchRelatedTrades-> Error When Fetching Related Trade: ", error);
    }
  };

  let isSharing = false;
  const onShareClick = async () => {
    if (navigator.share) {
      if (isSharing) return;

      const shareData = {
        title: "Trade Profile",
        url: window.location.href
      };

      isSharing = true;
      navigator
        .share(shareData)
        .catch((error) => console.error("onShareClick-> Error In Navigator When Sharing: ", error))
        .finally(() => {
          isSharing = false;
        });
    } else {
      try {
        try {
          await navigator.clipboard.writeText(window.location.href);
        } catch (err) {
          const textArea = document.createElement("textarea");
          textArea.value = window.location.href;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.body.removeChild(textArea);
        }
        alert("Link copied to clipboard");
        isSharing = false;
      } catch (error) {
        console.log("onShareClick-> Error In Navigator When Sharing (fallback): ", error);
      }
    }
  };

  const onSendChatClick = () => {
    setShowSendInChatModal(true);
  };

  const changeFollowStatus = async (isFollow) => {
    try {
      setShowFollowLoader(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: tradeData?.followDetails?.id,
            EntityTypeId: 7,
            EntityId: Number(id),
            UserId: Number(currentUserId),
            IsFollowing: isFollow,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(SAVE_FOLLOW_ENTITIES, obj, loginData?.accessToken);
      // After follow trades clear the community post redux
      const grouped = {
        all: [],
        products: [],
        projects: [],
        trades: []
      };
      dispatch(setCommunityPostIds(grouped));
      const [memberList, followDetails] = await Promise.all([
        fetchTradeMembers(),
        fetchFollowsEntity()
      ]);
      setTradeData((preValue) => ({ ...preValue, memberList, followDetails }));
      setShowFollowLoader(false);
    } catch (error) {
      setShowFollowLoader(false);
      console.log("changeFollowStatus-> Error When Trying TO Change Follow Status: ", error);
    }
  };

  const addProductToUserProfile = async () => {
    try {
      setShowAddToProfileLoader(true);
      const obj = {
        ReturnRecordId: false,
        ReturnRecordError: true,
        UserId: Number(currentUserId),
        SaveList: [
          {
            UserId: Number(currentUserId),
            TradeId: Number(id),
            TradeType: isUserTradeListEmpty ? "Main" : "Other",
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(SAVE_USER_TRADES, obj, loginData?.accessToken);
      if (!tradeData?.followDetails?.isFollowing) {
        await changeFollowStatus(true);
      }
      await fetchUserTrades();
      await getUserTradesExperiences();
      setIsAddedToProfile(true);
      setShowAddToProfileLoader(false);
    } catch (error) {
      setShowAddToProfileLoader(false);
      console.log("addProductToUserProfile-> Error When Trying To Add Trade To Profile: ", error);
    }
  };

  const removeTradeFromUserProfile = async () => {
    try {
      if (userExpTradeIdArray?.includes(currentTrade) || isUserMainTrade) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: TEXT_THIS_TRADE_CANNOT_DELETED
        };
        dispatch(setShowalert(alertObj));
        return;
      } else {
        setShowAddToProfileLoader(true);
        const obj = {
          UserId: Number(loginData?.userInformation?.UserId),
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: [
            {
              Id: Number(id),
              ModifiedBy: Number(loginData?.userInformation?.UserId)
            }
          ]
        };
        await Postrequestcall(DELETE_USER_TRADES, obj, loginData?.accessToken);
        setShowAddToProfileLoader(false);
        setIsAddedToProfile(false);
      }
    } catch (error) {
      setShowAddToProfileLoader(false);
      console.log(
        "removeTradeFromUserProfile-> Error When Removing Trade From User Profile: ",
        error
      );
    }
  };

  const onAnotherNameSave = async (name) => {
    try {
      setAnotherFormLoader(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: false,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            TradeId: id,
            Name: name,
            Current: false,
            RecordStatusId: 1,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(SAVE_TRADE_NAMES, obj, loginData?.accessToken);
      setTradeData((prevData) => ({
        ...prevData,
        tradeNames: [...prevData?.tradeNames, { name: name }]
      }));
      setSnackFlag(true);
    } catch (error) {
      console.log("onAnotherNameSave-> Error When Saving Trade Name: ", error);
    } finally {
      setShowAddAnotherNameModal(false);
      setAnotherFormLoader(false);
    }
  };

  const onReportClick = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.trades?.name,
      AppScreenId: Pages?.trades?.id,
      recordId: tradeData?.tradeDetails?.id
    };
    dispatch(setShowReport(reportObj));
  };

  const handleCloseSnackBar = () => {
    setSnackFlag(false);
  };

  if (noSuchData) {
    return (
      <Stack style={{ width: "100%", minHeight: "200px", marginTop: "20px" }}>
        <NoSuchPage />
      </Stack>
    );
  }

  return (
    <>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
        {showLoader ? (
          <Pageheader headerName={`${TEXT_TRADE}`} />
        ) : (
          <Pageheader headerName={`${TEXT_TRADE} | ${tradeData?.tradeDetails?.name}`} />
        )}
        <Card className="main-content-card">
          {showLoader ? (
            <Loader />
          ) : (
            <Box className="main-content-card-list" id={scrollTargetId}>
              <Grid container spacing={1.5}>
                <Grid
                  size={{
                    xs: 12,
                    md: 12
                  }}>
                  <Card className="pagelist-content">
                    <CardMedia
                      component="img"
                      height="300"
                      image={
                        !tradeData?.tradeDetails?.tradePictureUrl ||
                        tradeData.tradeDetails.tradePictureUrl.toLowerCase().includes("/null")
                          ? PlaceholderImg
                          : tradeData.tradeDetails.tradePictureUrl
                      }
                      alt={tradeData?.tradeDetails?.name}
                      onClick={() => {
                        setShowImagePreview(true);
                      }}
                    />
                    <Box sx={{ pb: 1,  pt: 1.5,  p: 2 }}  >
                      <Grid container>
                        <Grid size={{ xs: 12, md: 6 }}>
                          <ListItemText
                            primary={tradeData?.tradeDetails?.name}
                            secondary={TEXT_TRADE}
                          />
                        </Grid>
                        {!pathname.includes("proxySite") && (
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Stack sx={{ justifyContent: "flex-end", alignItems: "center" }} direction={"row"} spacing={1}>
                              <Button
                                loading={showFollowLoader}
                                variant="outlined"
                                onClick={() => {
                                  tradeData?.followDetails?.isFollowing
                                    ? setShowConformationModal("follow")
                                    : changeFollowStatus(true);
                                }}>
                                {tradeData?.followDetails?.isFollowing
                                  ? TEXT_FOLLOWING
                                  : BUTTON_FOLLOW}
                              </Button>
                              <Button
                                startIcon={
                                  isAddedToProfile ? <CheckIcon fontSize={"medium"} /> : null
                                }
                                loading={showAddToProfileLoader}
                                variant={isAddedToProfile ? "outlined" : "text"}
                                onClick={() => {
                                  isAddedToProfile
                                    ? setShowConformationModal("worked")
                                    : addProductToUserProfile();
                                }}>
                                {!isAddedToProfile && BUTTON_ADD_TO_PROFILE}
                              </Button>

                              <IconButton
                                aria-label="settings"
                                onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                                <MoreVertIcon />
                              </IconButton>
                            </Stack>
                          </Grid>
                        )}
                      </Grid>
                      {tradeData?.memberList?.length > 0 && (
                        <Stack sx={{ gap: 1,  justifyContent: "space-between", alignItems: "center"  }} direction={"row"} >
                          <Stack
                            style={{ width: "100%", scrollbarWidth: "none", overflow: "auto" }}
                            direction={"row"}
                            gap={1}>
                            {tradeData?.memberList?.map((member, index) => (
                              <Avatar
                                key={index}
                                src={member.pictureUrl}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setShowMemberList(true);
                                }}
                              />
                            ))}
                          </Stack>
                          <Stack>
                            <IconButton
                              onClick={() => {
                                setShowMemberList(true);
                              }}>
                              <KeyboardArrowRightIcon />
                            </IconButton>
                          </Stack>
                        </Stack>
                      )}
                    </Box>
                    <Tabs
                      sx={{ minHeight: "30px" }}
                      textColor="primary"
                      indicatorColor="primary"
                      value={activeTab}
                      onChange={(event, newTab) => setActiveTab(newTab)}
                      variant="scrollable">
                      {tabsOptions.map((tab, index) => (
                        <Tab key={index} value={tab.name} label={tab.value} />
                      ))}
                    </Tabs>
                  </Card>
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 4
                  }}>
                  <TradeAboutSection tradeNames={tradeData?.tradeNames} tradeData={tradeData} />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 8
                  }}>
                  {pathname.includes("proxySite") &&
                  (activeTab === "posts" ||
                    activeTab === "companies" ||
                    activeTab === "products" ||
                    activeTab === "projects") ? (
                    <SignInCard />
                  ) : (
                    <>
                      {activeTab === "posts" && (
                        <TradePostsSection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === "companies" && (
                        <TradeCompanySection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === "products" && (
                        <TradeProductSection id={id} scrollId={scrollTargetId} />
                      )}
                      {activeTab === "projects" && (
                        <TradeProjectSection id={id} scrollId={scrollTargetId} />
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          )}
        </Card>
      </Box>

      {showImagePreview && (
        <PictureViewer
          isOpen={showImagePreview}
          onClose={() => setShowImagePreview(false)}
          src={
            !tradeData?.tradeDetails?.tradePictureUrl ||
            tradeData.tradeDetails.tradePictureUrl.toLowerCase().includes("/null")
              ? PlaceholderImg
              : tradeData.tradeDetails.tradePictureUrl
          }
        />
      )}

      {showSendInChatModal && (
        <SendInChatModal
          isOpen={showSendInChatModal}
          onClose={() => {
            setShowSendInChatModal(false);
          }}
          fromTo="Trade"
          title={tradeData?.tradeDetails?.name}
          imageUrl={tradeData?.pictureList?.[0]?.pictureUrl ?? PlaceholderImg}
        />
      )}

      <Menu
        anchorEl={moreMenuAnchorEl}
        open={Boolean(moreMenuAnchorEl)}
        onClose={() => setMoreMenuAnchorEl(null)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
        {menuOptions.map((item, index) => {
          if (
            item.name === "Add another Trade name" &&
            (!isAddedToProfile ||
              tradeData?.followDetails?.isFollowing === undefined ||
              !tradeData?.followDetails?.isFollowing)
          ) {
            return null;
          }

          return (
            <MenuItem
              onClick={() => {
                if (item.name === "Share") {
                  onShareClick();
                } else if (item.name === "Send in Chat") {
                  onSendChatClick();
                } else if (item.name === "Add another Trade name") {
                  setShowAddAnotherNameModal(true);
                } else if (item.name === "Report") {
                  onReportClick();
                }
                setMoreMenuAnchorEl(null);
              }}
              style={{ color: item.name === "Report" ? BIRed : "#083DB8" }}
              key={index}
              dense>
              {item.value}
            </MenuItem>
          );
        })}
      </Menu>

      {showConformationModal === "follow" || showConformationModal === "worked" ? (
        <DeleteConfirmation
          open={true}
          onClose={() => setShowConformationModal(null)}
          headerText={
            showConformationModal === "follow"
              ? TEXT_ARE_YOU_SURE_TO_UNFOLLOW_TRADE_PAGE
              : TEXT_REMOVE_THIS_TRADE
          }
          onBadgeClick={() => {
            setShowConformationModal(null);
            showConformationModal === "follow"
              ? changeFollowStatus(false)
              : removeTradeFromUserProfile();
          }}
          actionBtnText={showConformationModal === "follow" ? BUTTON_YES : BUTTON_REMOVE}
        />
      ) : (
        <></>
      )}

      {showAddAnotherNameModal && (
        <AddAnotherNameModal
          onClose={() => {
            setShowAddAnotherNameModal(false);
          }}
          open={showAddAnotherNameModal}
          label={TEXT_ANOTHER_TRADE_NAME}
          onAnotherNameSave={onAnotherNameSave}
          anotherFormLoader={anotherFormLoader}
        />
      )}

      {showMemberList && (
        <MemberList
          isOpen={showMemberList}
          onClose={() => setShowMemberList(false)}
          members={tradeData?.memberList ?? []}
          from={"trade-profile"}
          setShowbtnLoader={setShowMemberBtnLoader}
          showBtnLoader={showMemberBtnLoader}
          setTradeData={setTradeData}
        />
      )}
      <Snackbar
        autoHideDuration={3000}
        open={snackFlag}
        onClose={handleCloseSnackBar}
        message={TEXT_ADDED_ADMIN}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        key={"bottomcenter"}
      />
    </>
  );
};

export default TradeProfile;

